import { Controller } from "@hotwired/stimulus"

// "Who can see what" (pmfit K6-7 "C"): filter the people list by name/email
// and by role (or only the people whose permissions were changed).
export default class extends Controller {
  static targets = ["search", "role", "row", "empty"]

  filter() {
    const q = (this.searchTarget.value || "").trim().toLowerCase()
    const role = this.roleTarget.value
    let shown = 0
    this.rowTargets.forEach(row => {
      const matchesText = !q || (row.dataset.search || "").includes(q)
      const matchesRole = !role || (role === "custom" ? row.dataset.custom === "true" : row.dataset.role === role)
      const show = matchesText && matchesRole
      row.classList.toggle("hidden", !show)
      if (show) shown += 1
    })
    this.emptyTarget.classList.toggle("hidden", shown > 0)
  }
}
